import React from "react";
import classnames from "classnames";
import classBind from "classnames/bind";

import styles from "./styles.scss";

let cx = classBind.bind(styles);

export default class FormCol extends React.Component {
  render() {
    var first = this.props.first;
    var last = this.props.last;
    var single = this.props.single;

    let className = cx({
      formCol: true,
      first: first,
      last: last,
      single: single,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
